import { useMemo, useState } from 'react'

import {
  LOAN_FORM_CONFIG,
  type LoanSimulatorConfigItem,
  type PossibleMonthlyInstallments,
} from '../constants'

type InputType = PossibleMonthlyInstallments | number

const useLoanForm = () => {
  const [installmentsRange, setInstallmentsRange] = useState(0)
  const [moneyAmountRange, setMoneyAmountRange] = useState(0)

  const getInputConfig = ({
    inputValue,
    config,
  }: {
    inputValue: number
    config: LoanSimulatorConfigItem<InputType>
  }) => {
    const { max, step, legend } = config

    return { min: 0, max: max / step, step: 1, legend, value: inputValue }
  }

  const installmentsInputConfig = useMemo(
    () =>
      getInputConfig({
        inputValue: installmentsRange,
        config: LOAN_FORM_CONFIG.installments,
      }),
    [installmentsRange],
  )

  const moneyAmountInputConfig = useMemo(
    () =>
      getInputConfig({
        inputValue: moneyAmountRange,
        config: LOAN_FORM_CONFIG.moneyAmount,
      }),
    [moneyAmountRange],
  )

  const formatInputValue = <T extends InputType>(
    value: number,
    config: LoanSimulatorConfigItem<T>,
  ): T => {
    const { step, min } = config

    if (value === 0) return min

    return (value * step) as T
  }

  return {
    moneyAmountInputConfig,
    installmentsInputConfig,
    formatInputValue,
    setInstallmentsRange,
    setMoneyAmountRange,
  }
}

export { useLoanForm }
